
'use strict'

#-----------------------------------------------------------------------------------------------------------
@on_exit = require '../dependencies/sindresorhus-exit-hook-2-2-1.js'

